import { Chip } from "@/components/chip";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import type { IssueStatus } from "@/lib/api";
import { issueStatusHint, issueStatusLabel, STATUS_TONE } from "@/lib/issues";
import { cn } from "@/lib/utils";

interface IssueStatusChipProps {
  status: IssueStatus;
  className?: string;
}

/**
 * An issue's status as a chip (Nieuw, Teruggekomen, Open, In behandeling,
 * Opgelost, Genegeerd), with what it means in a sentence in its tooltip, on
 * hover and on keyboard focus: on the Fouten page, an issue's page and the
 * home page.
 *
 *     <IssueStatusChip status={issue.status} />
 */
export function IssueStatusChip({ status, className }: IssueStatusChipProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Chip
          tone={STATUS_TONE[status]}
          tabIndex={0}
          data-status={status}
          className={cn(
            "focus-visible:ring-ring focus-visible:ring-2 focus-visible:outline-none",
            className,
          )}
        >
          {issueStatusLabel(status)}
        </Chip>
      </TooltipTrigger>
      <TooltipContent className="max-w-64 text-left">{issueStatusHint(status)}</TooltipContent>
    </Tooltip>
  );
}
